<template>
  <div style="padding: 0 20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" label-width="100px" :disabled="formLoading">
        <el-table border :data="express" style="width: 100%" :show-header="false">
          <el-table-column prop="no" width="80"></el-table-column>
          <el-table-column width="300">
            <template slot-scope="{ row }">
              <el-form-item label="物流公司">
                <el-select v-model="row.exp_code" placeholder="请选择" size="medium" :disabled="orderInfo.ship_status == 3">
                  <el-option
                      v-for="val in expressRelation"
                      :key="val.erp_code"
                      :label="val.erp_name"
                      :value="val.erp_code">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="360">
            <template slot-scope="{ row }">
              <el-form-item label="物流单号">
                <el-input size="medium" v-model="row.exp_no" :disabled="orderInfo.ship_status == 3"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="180">
            <template slot-scope="{ row }">
              <el-form-item label="sku数量">
                {{ row.order_item.length }}
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="row">
              <el-button type="primary" v-show="orderInfo.ship_status != 3" size="small" @click="showDialog(row.$index)">添加商品</el-button>
              <el-button v-show="express.length == 1 && orderInfo.ship_status != 3" @click="clearPackage" type="danger" size="small">
                清空
              </el-button>
              <el-button v-show="express.length > 1 && orderInfo.ship_status != 3" @click="delPackage(row.$index)" type="danger" size="small"
                         icon="el-icon-delete">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item style="margin-top: 20px" v-show="orderInfo.ship_status != 3">
          <el-button type="primary" @click="addPackage">添加包裹</el-button>
        </el-form-item>
        <el-form-item style="margin-top: 20px">
          <el-button type="primary" v-show="orderInfo.ship_status != 3" @click="onSubmit" :loading="onSubmitLoading">立即发货</el-button>
          <el-button @click="backPrePage()">取 消</el-button>
          <el-tooltip class="item" effect="dark" content="默认发货后自动发送短信，显示短信已发送次数，可补发" placement="top">
            <el-button type="primary" @click="sendExpressSms()" size="small" :loading="sendSmsLoading" :disabled="!(orderInfo.ship_status == 2)">发送短信，已发送{{orderInfo.sms_times}}次</el-button>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </el-row>

    <el-dialog title="添加商品" :visible.sync="dialogFormVisible">

      <el-form ref="form" label-width="100px">
        <el-table border :data="orderItem" style="width: 100%" @selection-change="handleSelectItem" ref="multipleTable">
          <el-table-column type="selection" width="55" :selectable="selectTable"></el-table-column>
          <el-table-column prop="product_title" label="商品名"></el-table-column>
          <el-table-column prop="sku_title" label="规格"></el-table-column>
          <el-table-column prop="amount" label="数量"></el-table-column>
          <el-table-column label="包裹">
            <template slot-scope="{ row }">
              {{ row.package_info == '' ? '-' : row.package_info }}
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearProduct">取 消</el-button>
        <el-button v-show="this.selectItem.length > 0" type="primary" @click="addProduct">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {getOrderExpress, getExpressRelation, saveOrderExpress, sendOrderExpressSms} from "@/api/order";
import {collect} from "collect.js";

export default {
  data: function () {
    return {
      sendSmsLoading: false,
      onSubmitLoading: false,
      dialogFormVisible: false,
      handleItemIndex: 0,
      formLoading: false,
      tableKey: 0,
      orderId: '',
      orderExpress: [],
      expressRelation: [],
      selectItem: [],
      orderItem: [],
      express: [
        {
          no: '包裹1',
          exp_code: '',
          exp_no: '',
          order_item: []
        }
      ],
      orderInfo:{},
    };
  },
  created: function () {
    this.orderId = this.$route.query.orderId;
    this.getExpressRelation();
    this.getOrderExpress();
  },
  methods: {
    getExpressRelation() {
      getExpressRelation().then(response => {
        this.expressRelation = response.data;
        this.expressRelation.unshift({
          erp_code: "",
          erp_name: "请选择物流公司"
        })
      });
    },
    getOrderExpress() {
      this.formLoading = true;
      getOrderExpress({
        order_id: this.orderId
      }).then(response => {
        this.express = response.data.order_express;
        this.orderItem = response.data.order_item_data;
        this.orderInfo = response.data.order_info;
        this.formLoading = false;

        if(this.express.length == 0){
          this.express = [{
            no: '包裹1',
            exp_code: '',
            exp_no: '',
            order_item: []
          }]
        }
        this.syncOrderItemAndExpressPackageInfoAndSelected();
      });
    },
    addPackage() {
      this.express.push({
        no: '包裹' + (this.express.length + 1),
        exp_code: '',
        exp_no: '',
        order_item: []
      })
    },
    delPackage(index) {
      // 删除物流包裹内 SKU的包裹信息、选中状态
      for (let i = 0, len = this.orderItem.length; i < len; i++) {
        if (collect(this.express[index].order_item).where('id', '==', this.orderItem[i].id).isNotEmpty()) {
          this.orderItem[i].selected = 0;
          this.orderItem[i].package_info = '';
        }
      }

      // 删除物流信息
      this.express.splice(index, 1);

      // 清洗物流数据的包裹信息
      for (let j = 0, len2 = this.express.length; j < len2; j++) {
        this.express[j].no = '包裹' + (j + 1)
      }

      this.syncOrderItemAndExpressPackageInfoAndSelected();
    },
    // 与物流数据同步SKU数据中的包裹信息、选中状态
    syncOrderItemAndExpressPackageInfoAndSelected() {
      for (let i = 0, len = this.orderItem.length; i < len; i++) {
        for (let j = 0, len2 = this.express.length; j < len2; j++) {
          if (collect(this.express[j].order_item).where('id', '==', this.orderItem[i].id).isNotEmpty()) {
            this.orderItem[i].package_info = this.express[j].no;
            this.orderItem[i].selected = 1;
          }
        }
      }
    },
    clearPackage() {
      if (this.express.length == 1) {
        this.express = [{
          no: '包裹1',
          exp_code: 'yto',
          exp_no: '',
          order_item: []
        }];
        for (let i = 0, len = this.orderItem.length; i < len; i++) {
          this.orderItem[i].selected = 0;
          this.orderItem[i].package_info = '';
        }
      }
    },
    showDialog(index) {
      this.handleItemIndex = index;
      this.dialogFormVisible = true;
    },
    addProduct() {
      this.express[this.handleItemIndex].order_item.push(...this.selectItem)
      // 同步SKU的包裹信息、选中状态
      for (let i = 0, len = this.orderItem.length; i < len; i++) {
        for (let j = 0, len2 = this.selectItem.length; j < len2; j++) {
          if (this.orderItem[i].id == this.selectItem[j].id) {
            this.orderItem[i].selected = 1;
            this.orderItem[i].package_info = this.express[this.handleItemIndex].no;
          }
        }
      }
      // 清理选中状态
      this.$refs.multipleTable.clearSelection();
      this.selectItem = [];
      this.dialogFormVisible = false;
    },
    clearProduct(){
      // 清理选中状态
      this.$refs.multipleTable.clearSelection();
      this.selectItem = [];
      this.dialogFormVisible = false;
    },
    handleSelectItem(val) {
      this.selectItem = val;
    },
    selectTable(row) {
      return row.selected != 1;
    },

    onSubmit() {
      if (
          collect(this.orderItem).where('selected', '==', '0').isNotEmpty() ||
          collect(this.express).where('exp_no', '==', '').where('order_item', '!=', []).isNotEmpty() ||
          collect(this.express).where('exp_code', '==', '').where('order_item', '!=', []).isNotEmpty()
      ) {
        this.$confirm('该订单内有商品未添加物流信息，是否继续发货', '提示', {
          confirmButtonText: '立即发货',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.save()
        }).catch(() => {});
      } else {
        this.save()
      }
    },
    save() {
      this.onSubmitLoading = true;
      saveOrderExpress({
        order_id: this.orderId,
        express: this.express
      }).then((res) => {
        this.onSubmitLoading = false;
        if (res.code == 1) {
          this.$message({
            showClose: true,
            duration: 6000,
            message: '操作成功',
            type: 'success'
          });
          this.getOrderExpress();
          this.backPrePage();
        }
      });
    },
    sendExpressSms() {
      this.sendSmsLoading = true;
      sendOrderExpressSms({
        order_id: this.orderId,
      }).then((res) => {
        this.sendSmsLoading = false;
        if (res.code == 1) {
          this.$message({
            showClose: true,
            duration: 6000,
            message: '短信提交成功',
            type: 'success'
          });
          this.getOrderExpress();
        }
      });
    },
    backPrePage() {
      if (window.location.host == 'dev.backend.zhangdefenspace.com') {
        window.open('http://dev.admin.defen.hzxinquanzi.com/?c=order&m=order_dian&p=20', '_parent');
      } else {
        window.open('http://admin.defen.hzxinquanzi.com/?c=order&m=order_dian&p=20', '_parent');
      }
      //window.history.go(-1);
      // this.$router.go(-1);
    },
  }
};
</script>
<style>
.el-form-item {
  margin-bottom: 0px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 70px;
  display: block;
}

.product-img {
  width: 80px;
  height: 80px;
  margin: 0 10px 0 0;
}
</style>

